import { render, staticRenderFns } from "./WizardTab.vue?vue&type=template&id=ef4ce8d4&"
import script from "./WizardTab.vue?vue&type=script&lang=js&"
export * from "./WizardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef4ce8d4')) {
      api.createRecord('ef4ce8d4', component.options)
    } else {
      api.reload('ef4ce8d4', component.options)
    }
    module.hot.accept("./WizardTab.vue?vue&type=template&id=ef4ce8d4&", function () {
      api.rerender('ef4ce8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/WizardTab.vue"
export default component.exports